import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import ViewListIcon from "@mui/icons-material/ViewList";
import loader from "../../assets/loader.webp";
import Pagination from "../../components/Pagination";
import { fetchData, deleteData } from "../../utility/managerApi";
import EditProduct from "./EditProduct";
import ConfirmModal from "../../components/ConfirmModal";
import { Link } from "react-router";
import ExportProductList from "./ExportProductList";

import ProductsTableBody from "./ProductsTableBody";

function Products() {
  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState();
  const [edittab, setEdittab] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState({});
  const [productIdToDelete, setProductIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchProducts = async (page = 1, search = "") => {
    const response = await fetchData("products", currentPage, searchData);
    setProductData(response.data.data);

    setTotalPage(response.data.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  useEffect(() => {
    fetchProducts(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    fetchProducts(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = (id) => {
    setProductIdToDelete(id);
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleConfirmDelete = async () => {
    await deleteData("products/delete/", productIdToDelete);
    fetchProducts(currentPage); //
    setIsModalOpen(false);
  };

  if (isLoading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className=" w-10 lg:w-20 " />
      </div>
    );
  }

  return (
    <div className=" flex lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col gap-4 w-full ">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {" "}
            <ViewListIcon />{" "}
            <h3 className="text-2xl font-semibold">Products</h3>
          </div>

          <div className="flex flex-row gap-4 flex-wrap">
            <ExportProductList />

            <Link
              to="/manager/addproduct"
              className="px-4 py-3 text-white rounded-lg bg-blue-500"
            >
              Add Product <AddIcon />
            </Link>
            <Link
              to="/manager/category"
              className="px-4 py-3 text-white rounded-lg bg-[#5D6679]"
            >
              Add Category <AddIcon />
            </Link>
          </div>
        </div>
        {edittab && (
          <EditProduct
            singleData={singleData}
            setSingleData={setSingleData}
            setEdittab={setEdittab}
            setLoading={setIsLoading}
            currentPage={currentPage}
            fetchProducts={fetchProducts}
          />
        )}
        {!edittab && (
          <div className=" bg-white flex flex-col lg:justify-normal w-full lg:gap-4 overflow-x-auto items-center py-6 px-8">
            <div className="flex  w-full">
              <div>
                {/* Consider resarching for MUI UI search bar  */}
                <input
                  type="text"
                  placeholder="Search for"
                  name="cat_name"
                  // id="email"
                  value={searchData}
                  onChange={handleChange}
                  className="border-2 border-gray-400 w-60 p-2 px-6"
                />
              </div>
            </div>

            <div className="w-full">
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">
                      IMAGE
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      PRODUCT NAME
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      STOCK
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      PRICE
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      CATEGORY
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      ACTIONS
                    </th>
                  </tr>
                </thead>
                <ProductsTableBody
                  productData={productData}
                  setSingleData={setSingleData}
                  setEdittab={setEdittab}
                  handleDelete={handleDelete}
                />
              </table>
              <Pagination
                onPageChange={handleCurrentPage}
                totalPage={totalPage}
                currentPage={currentPage}
                setIsNextLoading={setIsNextLoading}
                setIsPrevLoading={setIsPrevLoading}
                isPrevLoading={isPrevLoading}
                isNextLoading={isNextLoading}
              />
            </div>
          </div>
        )}
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the product?"
      />
    </div>
  );
}

export default Products;
